import { Title } from "../components/base/Title";
import { Button } from "../components/base/Button";

import { Card } from "components/base/Card";

type ErrorProps = {
  resetError?: () => void;
};

export default function Error() {

  return (
    <>
      <div className="h-[var(--navbar-height)] bg-BGheader py-2">
        {/* Logo à gauche */}
				<div className="flex items-center justify-center">
					<a href="/" className="flex items-center w-16" aria-label='Accueil'>
						<img src="/logo.svg" alt="Logo du site" className="h-14 w-auto" />
					</a>
				</div>
      </div>
    <div
      className="min-h-[calc(100vh-var(--navbar-height))] flex flex-col items-center justify-center text-center"
      style={{
        backgroundImage: 'url(/bg-error.JPG)',
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}
    >
      <div className='absolute inset-0 bg-gray-600 opacity-30 h-[calc(100vh-var(--navbar-height))] top-[var(--navbar-height)]' />
      <Card className="p-8 flex flex-col items-center justify-center z-10 shadow-sm shadow-primary-100">
        {/* Logo et nom du site */}
        <div className="flex items-center gap-4 mb-6">
          <img src="/logo.svg" alt="Logo du site" className="w-24" />
          <Title type="h1" className="text-8xl font-extrabold text-primary">Oups !</Title>
        </div>

        <Title type="h4" className="mb-6">Une erreur est survenue. Veuillez réessayer plus tard.</Title>

        {/* Bouton de retour */}
        <Button
          onClick={() => window.location.href = "/"}
        >
          Retour à l’accueil
        </Button>
      </Card>
    </div>
    </>
  );
}
